<label class="ideals-checkbox__layout" [attr.for]="id">
  <span class="ideals-checkbox__checkmark"
        [ngClass]="checkboxClasses"
        [attr.data-ideals]="'checkbox' + id"
        tabindex="0"
        (keydown.space)="toggle()">
    <input class="ideals-checkbox__input"
           type="checkbox"
           [id]="id"
           [checked]="value"
           [disabled]="isInputDisabled"
           (change)="onChange($event)"
           [attr.data-ideals]="dataIdealsAttr">
  </span>
  <span class="ideals-checkbox__label">
    <ng-content></ng-content>
  </span>
</label>
